"use client";

import { useEffect, useState } from "react";
import { ShieldAlert, X } from "lucide-react";
import {
  getImpersonationInfo,
  stopImpersonation,
  type ImpersonationInfo,
} from "@/lib/api";

// Banner global vermelho que aparece em qualquer rota quando o admin
// está visualizando como outro cliente. Fechar (X) encerra a sessão e
// volta pro próprio admin. O token de impersonação fica em
// sessionStorage, então fechar a tab também encerra.

export function ImpersonationBanner() {
  const [info, setInfo] = useState<ImpersonationInfo | null>(null);

  useEffect(() => {
    const refresh = () => setInfo(getImpersonationInfo());
    refresh();
    // Verifica a cada 30s pra capturar expiração.
    const t = setInterval(refresh, 30_000);
    return () => clearInterval(t);
  }, []);

  if (!info) return null;

  const minutesLeft = Math.max(
    0,
    Math.round((info.expiresAt - Date.now()) / 60_000)
  );

  const handleStop = () => {
    stopImpersonation();
    // Recarrega pra reaplicar o token do admin (do localStorage).
    window.location.href = "/admin/usuarios";
  };

  return (
    <div className="sticky top-0 z-[200] bg-gradient-to-r from-red-600 to-red-700 text-white text-sm shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="h-4 w-4 shrink-0" />
          <p className="leading-tight">
            <span className="font-bold">Visualizando como </span>
            <span className="font-mono">{info.userName}</span>
            <span className="opacity-75"> ({info.userEmail})</span>
            <span className="text-[10px] opacity-75 ml-2">
              · {minutesLeft}min restantes
            </span>
          </p>
        </div>
        <button
          onClick={handleStop}
          className="inline-flex items-center gap-1.5 rounded-lg bg-white/15 hover:bg-white/25 px-3 py-1 text-xs font-bold transition-colors"
        >
          <X className="h-3.5 w-3.5" />
          Sair e voltar pro admin
        </button>
      </div>
    </div>
  );
}
